const { env } = require('../env');
const {REACT_APP_BUS_NAME} = env

module.exports = {
  footerText: `Copyright ${REACT_APP_BUS_NAME} ©`
}
